/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { authServiceAccountsGet } from "../../funcs/authServiceAccountsGet.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.GetServiceAccountRequest$inboundSchema,
};

export const tool$authServiceAccountsGet: ToolDefinition<typeof args> = {
  name: "auth-service-accounts-get",
  description: `Get a service account`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await authServiceAccountsGet(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
